import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=65fa997a&scoped=true"
import script from "./LoginForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginForm.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LoginForm.vue?vue&type=style&index=0&id=65fa997a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fa997a",
  null
  
)

export default component.exports